export const timeDiffText = time => {
  let now = new Date().getTime();
  let diff = now - time;
  let minutes = Math.round(diff / 60000);
  if (minutes >= 1) {
    return `saved ${minutes} minutes ago`;
  } else {
    return `saved just now`;
  }
};

export const getTimestamp = (seconds, includeHours = false) => {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (includeHours || hh) {
    return `${pad(hh)}:${pad(mm)}:${ss}`;
  }
  return `${pad(mm)}:${ss}`;
};

function pad(string) {
  return ('0' + string).slice(-2);
}
